const currentDate = new Date();
const nextMonthDate = new Date(
  currentDate.getFullYear(),
  currentDate.getMonth() + 1,
  1
);
export const formatNextMonth = `${nextMonthDate.toLocaleString("default", {
  month: "long",
})} 1st, ${nextMonthDate.getFullYear()}`;
